import NewsletterForm from "@/components/feature/NewsletterForm";

export default function SubscribeSection() {
  return (
    <section id="subscribe" className="bg-accent-100 border-y border-accent-200 scroll-mt-24">
      <div className="px-4 md:px-6 xl:px-10 py-14 md:py-20">
        <div className="max-w-[900px] mx-auto text-center">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50 text-accent-800 text-xs tracking-wider mb-5">
            <i className="ri-notification-3-line" />
            吃瓜日报
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            把本周的打榜观察，写成一封信
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700 max-w-[640px] mx-auto">
            每周挑出最值得看的三条票数异常、一份账目分析和一场规则争议，不标题党，不带节奏。
          </p>

          <div className="mt-8 text-left">
            <NewsletterForm />
          </div>
        </div>
      </div>
    </section>
  );
}